export default "__VITE_ASSET__7fe0ad43__"